import {nthArg, get, set, pluralize, transform, createSelector} from 'helpers';

export const files = createSelector(
  state => state.files,
  files => transform(files, (result, file) => {
    if (file.contentPlain && file.contentPrefix) {
      file = {
        ...file,
        url: file.contentPrefix + file.contentPlain,
      }
    }
    const path = pluralize(file.type) + '.' + file.modelType + file.modelId;
    set(result, path, get(result, path) || []);
    get(result, path).push(file);
  }
));

export const images = createSelector(
  [ files, nthArg(1) ],
  ( files, { id, context }) => get(files.images, pluralize(context, 1) + id),
);

export const audio = createSelector(
  [ files, nthArg(1) ],
  ( files, { id, context }) => get(files.audio, pluralize(context, 1) + id),
);
